import { createContext } from 'react';
import {PaymentProvider} from "../../../api";

export type ModalName = 'promocode' | 'profile' | 'support' | 'payment' | 'connection';
type SetIsOpenFunction = (isOpen: boolean) => boolean;
export type PropSetModal = {[key: string]: ((id: number, providerId: string) => void) | string | number | PaymentProvider[] | undefined}

interface Modal {
    isOpen: boolean;
    modalName: ModalName | undefined;
    prop: PropSetModal | undefined;
    setModalName: (param: ModalName | undefined) => void | undefined;
    setProp: (prop?: PropSetModal ) => void | undefined;
    setIsOpen: (param: boolean | SetIsOpenFunction) => void | undefined;
}

export const ModalContext = createContext<Modal>({
    isOpen: false,
    modalName: undefined,
    prop: undefined,
    setModalName: () => undefined,
    setIsOpen: () => undefined,
    setProp: () => undefined,
});
